/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_Faq_Q7Inputs */

const en_to_csv_faq_q7 = /** @type {(inputs: To_Csv_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does the output use CRLF line endings?`)
};

const ko_to_csv_faq_q7 = /** @type {(inputs: To_Csv_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`출력이 CRLF 줄바꿈을 쓰나요?`)
};

const ja_to_csv_faq_q7 = /** @type {(inputs: To_Csv_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出力は CRLF の改行を使いますか`)
};

/**
* | output |
* | --- |
* | "Does the output use CRLF line endings?" |
*
* @param {To_Csv_Faq_Q7Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_faq_q7 = /** @type {((inputs?: To_Csv_Faq_Q7Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_Faq_Q7Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_faq_q7(inputs)
	if (locale === "ko") return ko_to_csv_faq_q7(inputs)
	return ja_to_csv_faq_q7(inputs)
});